
const serviceUrl = import.meta.env.MODE == "development" ? 
    "https://localhost:8080/dev" :
    `https://${import.meta.env.VITE_STAGE}-api.benefit-flow.com`;

export default serviceUrl;